module.exports = __webpack_public_path__ + "static/img/device-super-fetal.812a18c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/device-super-fetal.png
// module id = 9oFQ
// module chunks = 1